import { IRotaManagementRotaFilterParams, IRotaManagementRotaProvidersProps } from "@/api_framework/api_modals/Rota";
import RotaCalendarComponent from "@/app/components/ui/Calendar/RotaCalender";
import SearchableSelectMenu from "@/app/components/ui/SelectMenus/CitySelectMenu/index";
import SearchableMultiSelectMenu from "@/app/components/ui/SelectMenus/MultiSelectMenu";
import { useRotaShiftCategoryAPI } from "@/app/hooks/api_hooks/Rota/useRotaShiftCategoryAPI";
import { useRotaShiftFilterAPI } from "@/app/hooks/api_hooks/Rota/useRotaShiftFilterAPI";
import { useRotaShiftProvidersAPI } from "@/app/hooks/api_hooks/Rota/useRotaShiftProviderAPI";
import { useOrgCitiesListAPI } from "@/app/hooks/api_hooks/org/useOrgCitiesListAPI";
import { useLoader } from "@/app/hooks/useLoader";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { IRotaState, setRotaFilter } from "@/app_redux/reducers/slices/auth/rota_slice";
import { addDays, format, getDay, startOfWeek, subDays } from "date-fns";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import CopyShiftModalComponent from "../Modals/CopyShiftModalComponent/index";

export interface IRotaFiltersFormFields {
  cityId: string;
  cityName: string;
  clinic: Array<string>;
  category: string;
  categoryId: Array<string | number>;
  provider: Array<string>;
  providerId: Array<string>;
  date?: Array<string>;
}

const FilterComponent = ({
  copyActive,
  setCopyActive,
  selectedClinics,
  setDateRange,
  dateRange,
  setCityNameSelection,
  setSelectedClinics,
}) => {
  const [firstRender, setFirstRender] = useState<boolean>(false);
  const { getRouteKey } = useRouter();
  const routeId = getRouteKey("ROTA", "id");
  const dispatch = useAppDispatch();
  const { routeState: categoryData } = useRouteInfo(routeId);
  const isRotaLoading = useLoader("isClinicWiseRotaListInProgress");

  const { category, provider, cities: cityList, clinics: clinicsOrg, RotaFilter } = categoryData.state as IRotaState;

  const fetchCities = useOrgCitiesListAPI("ROTA");
  const { execute: fetchProviderList } = useRotaShiftProvidersAPI();
  const fetchCliniRotaDetails = useRotaShiftFilterAPI();
  const fetchShiftCategoryAPI = useRotaShiftCategoryAPI();

  const [categoryId, setCategoryId] = useState([]);
  const [currentSelectedDate, setCurrentSelectedDate] = useState<Date | number>();
  const [displayDateString, setDisplayDateString] = useState<string>("");

  const cityOrgItem = useSelectMenuReducer(cityList, "name", "id");
  const clinicsOrgItem = useSelectMenuReducer(clinicsOrg, "display_name", "id", {
    withAllSelectOption: false,
    allSelectItemOptions: {
      title: "All Clinics",
    },
  });
  const categoryListItem = useSelectMenuReducer(category, "staff_category_name", "staff_category_id", {
    withAllSelectOption: false,
    allSelectItemOptions: {
      title: "All",
    },
  });
  const providerListItem = useSelectMenuReducer(provider, "name", "staff_id");

  const formHook = useForm<IRotaFiltersFormFields>({
    mode: "onChange",
    defaultValues: {
      cityId: "1",
      cityName: "Gurugram",
      clinic: ["910d866c-2384-11ed-8ca0-1e00da26097a"],
      categoryId: [7],
    },
  });

  useEffect(() => {
    fetchCities({
      withClinics: true,
      staffCategoryId: "2",
      withClinicProviders: false,
      clinicOptions: {
        selectFirst: true,
      },
    });
    fetchShiftCategoryAPI("from_rota");
  }, []);

  const handelCLick = () => {
    const form_data = formHook.getValues();

    dispatch(
      setLoading({
        key: "isClinicWiseRotaListInProgress",
        status: true,
      }),
    );

    const constructedBody: IRotaManagementRotaFilterParams = {
      clinic_ids: form_data.clinic,
      staff_ids: form_data.providerId,
      provider_category_ids:
        categoryId[0] === "-1"
          ? category?.map((c) => c.id)?.map((number) => String(number))
          : form_data.categoryId.length > 1
            ? form_data.categoryId.map((number) => String(number))
            : [`${form_data.categoryId}`],
      from_date: dateRange[0]?.id,
      to_date: dateRange[6]?.id,
    };
    fetchCliniRotaDetails(constructedBody);
    setCityNameSelection(form_data?.cityName);

    dispatch(setRotaFilter({ data: constructedBody }));
  };

  const fetchProviderByCategory = () => {
    const form_data = formHook.getValues();

    const constructedBody: IRotaManagementRotaProvidersProps = {
      provider_category_ids:
        form_data?.categoryId[0] === "-1"
          ? category?.map((c) => c.id)?.map((number) => String(number))
          : form_data.categoryId.length > 1
            ? form_data.categoryId.map((number) => String(number))
            : [`${form_data.categoryId}`],
      clinic_ids: form_data.clinic,
    };
    // if (form_data?.categoryId?.length > 0) {
    fetchProviderList(constructedBody, "rota");
    // }
  };

  useEffect(() => {
    if (formHook.getValues("clinic")?.length > 0 && formHook.getValues("categoryId")?.length > 0 && !firstRender) {
      fetchProviderByCategory();
    }
  }, [formHook.watch("clinic"), formHook.watch("categoryId")]);

  useEffect(() => {
    if (formHook.getValues("providerId")?.length > 0 && dateRange?.length > 0 && !firstRender) {
      handelCLick();
      setFirstRender(true);
    }
  }, [formHook.watch("providerId"), dateRange]);

  useEffect(() => {
    if (dateRange) {
      handelCLick();
    }
  }, [dateRange]);

  const getDatesBetween = (startDate, endDate) => {
    const weekdays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const dates = [];
    let currentDate = new Date(startDate);
    const dayEnd = new Date(endDate);
    const formattedStartDate = format(currentDate, "dd MMM");
    const formattedEndDate = format(dayEnd, "dd MMM");

    const dateRange = `${formattedStartDate} - ${formattedEndDate}`;

    setCurrentSelectedDate(currentDate);
    setDisplayDateString(dateRange);

    while (currentDate <= new Date(endDate)) {
      const dayOfWeek = getDay(currentDate);

      if (dayOfWeek >= 0 && dayOfWeek <= 7) {
        const formattedDate = format(currentDate, "yyyy-MM-dd");
        const dayAbbreviation = weekdays.shift();
        dates.push({ title: dayAbbreviation, id: formattedDate });
      }

      currentDate = addDays(currentDate, 1);
    }
    setDateRange(dates);
  };

  const getWeekDateRange = (date) => {
    const startOfCurrentWeek = startOfWeek(date, { weekStartsOn: 1 }); // Monday
    const endOfCurrentWeek = addDays(startOfCurrentWeek, 6); // Sunday
    getDatesBetween(format(startOfCurrentWeek, "yyyy-MM-dd"), format(endOfCurrentWeek, "yyyy-MM-dd"));
  };

  useEffect(() => {
    getWeekDateRange(new Date());
  }, []);

  const nextWeekHandelFunction = () => {
    setSelectedClinics([]);
    setCopyActive(false);
    const nextWeekStartDate = addDays(startOfWeek(currentSelectedDate, { weekStartsOn: 1 }), 7);
    getDatesBetween(format(nextWeekStartDate, "yyyy-MM-dd"), format(addDays(nextWeekStartDate, 6), "yyyy-MM-dd"));
  };

  const prevWeekHandelFunction = () => {
    setSelectedClinics([]);
    setCopyActive(false);
    const prevWeekStartDate = subDays(startOfWeek(currentSelectedDate, { weekStartsOn: 1 }), 7);
    getDatesBetween(format(prevWeekStartDate, "yyyy-MM-dd"), format(addDays(prevWeekStartDate, 6), "yyyy-MM-dd"));
  };

  useEffect(() => {
    if (RotaFilter) {
      formHook.setValue("clinic", RotaFilter?.clinic_ids);
      formHook.setValue("providerId", RotaFilter?.staff_ids);
      getDatesBetween(RotaFilter?.from_date, RotaFilter?.to_date);
      // formHook.setValue("", RotaFilter?.staff_ids);
    }
  }, []);

  const handelPermisionButton = () => {
    const form_data = formHook.watch();
    if (form_data.cityId && form_data.clinic?.length > 0 && form_data.categoryId && form_data.providerId?.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <div className="">
      <h1 className="text-base font-semibold pt-3">Staff Schedule Management</h1>
      <div className="flex justify-between my-5">
        <div className="col-span-7">
          <div className="grid grid-cols-5 gap-[10px]">
            <div>
              <input type="hidden" {...formHook.register("cityId")} />
              <SearchableSelectMenu
                errorMessages={[{ message: "City is required", type: "required" }]}
                onSelectItem={(item) => {
                  if (item) {
                    formHook.setValue("cityName", item.title);

                    formHook.setValue("cityId", item.id);
                    formHook.setValue("providerId", null);
                    fetchCities({
                      withClinics: true,
                      staffCategoryId: "2",
                      withClinicProviders: false,
                      clinicOptions: {
                        cityId: item.id,
                      },
                    });
                  }
                }}
                fieldError={formHook.formState.errors.cityName}
                register={formHook.register("cityName", { required: true })}
                selectItems={cityOrgItem}
                placeholder="Select City"
                showTooltips={true}
                showTypedErrors={true}
                showDropdownIcon={true}
                defaultSelected={cityOrgItem?.filter((oc) => oc.id === formHook.watch("cityId"))[0]}
                listBoxClassName="w-full"
                className="text-gray-800 "
                containerClassName="w-full"
              />
            </div>
            <div>
              <SearchableMultiSelectMenu
                errorMessages={[{ message: "Required", type: "required" }]}
                fieldError={formHook.formState.errors.clinic}
                register={formHook.register("clinic", {
                  required: true,
                })}
                withSelectAll
                // defaultSelectAll
                withDropDownSearch
                containerClassName="w-full"
                showTypedErrors={false}
                onSelectItem={(items) => {
                  // Remove if -1 is selected that means all

                  const clinicIds = items.map((i) => i.id);
                  formHook.setValue("clinic", clinicIds);
                  fetchProviderByCategory();
                  formHook.setValue("providerId", null);
                }}
                showTooltips={true}
                placeholder="Select Clinics"
                defaultSelected={clinicsOrgItem?.filter((c) => formHook.watch("clinic")?.includes(c.id))}
                selectItems={clinicsOrgItem}
              />
            </div>
            <div>
              <SearchableMultiSelectMenu
                errorMessages={[{ message: "Required", type: "required" }]}
                fieldError={formHook.formState.errors.categoryId}
                register={formHook.register("categoryId", {
                  required: true,
                })}
                withSelectAll
                withDropDownSearch
                containerClassName="w-full"
                showTypedErrors={false}
                onSelectItem={(items) => {
                  // Remove if -1 is selected that means all
                  const categoryIds = items.map((i) => i.id);
                  const categoryIdsString = items.map((i) => i.id?.toString());
                  formHook.setValue("categoryId", categoryIds);
                  setCategoryId(categoryIdsString);
                  fetchProviderByCategory();
                  formHook.setValue("providerId", []);
                }}
                showTooltips={true}
                placeholder="Select Category"
                defaultSelected={categoryListItem?.filter((c) => formHook.watch("categoryId")?.includes(c.id))}
                selectItems={categoryListItem}
              />
            </div>
            <div className="">
              <SearchableMultiSelectMenu
                onSelectItem={(items) => {
                  const providerId = items.map((i) => i.id);
                  formHook.setValue("providerId", providerId);
                  handelPermisionButton();
                }}
                withDropDownSearch
                errorMessages={[{ message: "Required", type: "required" }]}
                fieldError={formHook.formState.errors.providerId}
                register={formHook.register("providerId", {
                  required: true,
                })}
                withSelectAll
                defaultSelectAll
                showTooltips={true}
                containerClassName="w-full"
                showTypedErrors={false}
                placeholder="Select Provider"
                defaultSelected={providerListItem?.filter((c) => formHook.watch("providerId")?.includes(c.id))}
                selectItems={providerListItem}
              />
            </div>
            <button
              disabled={handelPermisionButton()}
              className={`rounded-md  ${!handelPermisionButton() ? "bg-black" : "bg-gray-400"} 
             rounded-md text-xs font-semibold text-white px-4 ${isRotaLoading ? "cursor-not-allowed" : "cursor-pointer"}`}
              onClick={() => handelCLick()}
            >
              Apply Filters
            </button>
          </div>
        </div>
        <div className="col-span-4">
          <div className="flex gap-3">
            <div>
              <RotaCalendarComponent
                // showFutureYears={true}
                errorMessages={[{ message: "Date is required", type: "required" }]}
                register={formHook.register("date", {
                  required: true,
                })}
                showTypedErrors={false}
                fieldError={formHook.formState.errors.date}
                onSelectDate={(date) => {
                  const selectedDate = date;
                  getWeekDateRange(selectedDate);
                  formHook.setValue("date", [""]);
                }}
                className=""
                prevWeekHandelFunction={prevWeekHandelFunction}
                nextWeekHandelFunction={nextWeekHandelFunction}
                displayDateString={displayDateString}
              />
            </div>
            <div>
              {copyActive ? (
                <div className="flex gap-2 ">
                  {" "}
                  <CopyShiftModalComponent
                    dateRange={dateRange}
                    setCopyActive={setCopyActive}
                    selectedClinics={selectedClinics}
                    setSelectedClinics={setSelectedClinics}
                  />
                  <button
                    className="bg-[#f2f4f6] text-black font-semibold text-xs rounded-md py-2 px-10"
                    onClick={() => setCopyActive(false)}
                  >
                    Cancel
                  </button>
                </div>
              ) : (
                <button
                  className="bg-[#F2F4F6] text-black font-semibold text-xs rounded-md py-2 px-4 flex items-center gap-1"
                  onClick={() => setCopyActive(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5A3.375 3.375 0 0 0 6.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0 0 15 2.25h-1.5a2.251 2.251 0 0 0-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 0 0-9-9Z"
                    />
                  </svg>

                  <p>Select to Copy Shifts</p>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FilterComponent;
